function createPredicate(filterString) {
    try {
        var filterObj_1 = JSON.parse(filterString);
        return function (obj) {
            if ((filterObj_1 === null || filterObj_1 === void 0 ? void 0 : filterObj_1.must) && !filterObj_1.must.every(function (condition) { return evaluateCondition(condition, obj); })) {
                return false;
            }
            if ((filterObj_1 === null || filterObj_1 === void 0 ? void 0 : filterObj_1.must_not) && filterObj_1.must_not.some(function (condition) { return evaluateCondition(condition, obj); })) {
                return false;
            }
            if ((filterObj_1 === null || filterObj_1 === void 0 ? void 0 : filterObj_1.should) && !filterObj_1.should.some(function (condition) { return evaluateCondition(condition, obj); })) {
                return false;
            }
            return true;
        };
    }
    catch (error) {
        console.error('Error parsing filter string:', error);
        return function () { return false; };
    }
}
function evaluateCondition(condition, obj) {
    if (condition.term) {
        for (var key in condition.term) {
            if (obj[key] !== condition.term[key])
                return false;
        }
    }
    if (condition.terms) {
        for (var key in condition.terms) {
            if (!condition.terms[key].includes(obj[key]))
                return false;
        }
    }
    return true;
}

export { createPredicate };
//# sourceMappingURL=condition.js.map
